import { render, staticRenderFns } from "./base-home-calendar-content.vue?vue&type=template&id=538d70c9&scoped=true&"
import script from "./base-home-calendar-content.vue?vue&type=script&lang=ts&"
export * from "./base-home-calendar-content.vue?vue&type=script&lang=ts&"
import style0 from "./base-home-calendar-content.vue?vue&type=style&index=0&id=538d70c9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d70c9",
  null
  
)

export default component.exports